jd_allItems = {};

jd_allItems["Dinosaurs"] = 0;
	jd_allItems["Carcharodontosaurus"] = 1;
	jd_allItems["Spinosaurus"] = 1;
    jd_allItems["Tyrannosaurus rex"] = 1;
	jd_allItems["Abelisaurus"] = 1;
	jd_allItems["Dromaeosaur"] = 1;
	jd_allItems["Triceratops"] = 1;
	jd_allItems["Edmontosaurus"] = 1;
	jd_allItems["Brachylophosaurus"] = 1;
    jd_allItems["Coprolites"] = 1;
    jd_allItems["Dinosaur Age Mammals"] = 1;
	jd_allItems["Dinosaur Egg Shells"] = 1;
	jd_allItems["Thescelosaurus"] = 1;
	jd_allItems["Rebbachisaurus"] = 1;
	jd_allItems["Basilosaurus (Primitive Whale)"] = 1;
	jd_allItems["Dinosaur - Museum Grade"] = 1;
	jd_allItems["Hadrosaurus"] = 1;
    jd_allItems["Albertosaurus"] = 1;
    jd_allItems["Suchomimus"] = 1;
    jd_allItems["Ouranosaurus"] = 1;
    jd_allItems["Ankylosaurus"] = 1;
    jd_allItems["Saltasaurus Titanosaur"] = 1;
    jd_allItems["Eocarcharia"] = 1;
    jd_allItems["Jurassic Sauropods"] = 1;
    jd_allItems["Kryptops"] = 1;
    jd_allItems["Afrovenator (Megalosaurid)"] = 1;
    jd_allItems["Nigersaurus"] = 1;
    jd_allItems["Elrhazosaurus"] = 1;
jd_allItems["Reptiles"] = 0;
	jd_allItems["Pterosaur"] = 1;
	jd_allItems["Mosasaur"] = 1;
    jd_allItems["Plesiosaur"] = 1;
	jd_allItems["Crocodile"] = 1;
	jd_allItems["Turtle"] = 1;
    jd_allItems["Sea Snake"] = 1;
    jd_allItems["Coprolites"] = 1;
	jd_allItems["Reptile Teeth Jewelry"] = 1;
	jd_allItems["Unidentified Reptiles Vertebrae Bones"] = 1;
	jd_allItems["Reptiles - Museum Grade"] = 1;
	jd_allItems["Snakes"] = 1;
	jd_allItems["Sinohydrosaurus lingyuanensis"] = 1;
	jd_allItems["Keichousaurus"] = 1;
    jd_allItems["Ichthyosaur"] = 1;
jd_allItems["Sharks"] = 0;
	jd_allItems["Notidanodon"] = 1;
	jd_allItems["Otudus"] = 1;
	jd_allItems["Hybodus"] = 1;
	jd_allItems["Squalicorax"] = 1;
    jd_allItems["Weltonia"] = 1;
    jd_allItems["Hexanchus"] = 1;
    jd_allItems["Cretolamna"] = 1;
    jd_allItems["Shark vertebrae"] = 1;
    jd_allItems["Shark Teeth Collections"] = 1;
    jd_allItems["Megalodon"] = 1;
	jd_allItems["Skark teeth bulk"] = 1;
	jd_allItems["Ginglymostoma"] = 1
    jd_allItems["Shark teeth jewelry"] = 1
jd_allItems["Fish"] = 0;
	jd_allItems["Onchopristis (Giant Sawfish)"] = 1;
    jd_allItems["Knightia"] = 1;
	jd_allItems["Peyeria"] = 1;
	jd_allItems["Ceratodus"] = 1;
	jd_allItems["Enchodus"] = 1;
    jd_allItems["Aidachar"] = 1;
    jd_allItems["Fish scales"] = 1;
    jd_allItems["Fish Vertebrae"] = 1;
	jd_allItems["Schizorhiza (Sawfish)"] = 1;
	jd_allItems["Mawsonia (Coelacanth)"] = 1;
    jd_allItems["Lepidotes"] = 1;
    jd_allItems["Lepidotes"] = 1;
    jd_allItems["Phacodus"] = 1;
    jd_allItems["Stephanodus"] = 1;
    jd_allItems["Pharyngeal Teeth"] = 1;
    jd_allItems["Myliobatis"] = 1;
	jd_allItems["Fish teeth bulk"] = 1;
	jd_allItems["Palaeonotopterus"] = 1;
	jd_allItems["Calamopleurus"] = 1;
	jd_allItems["Sclerorhynchus"] = 1;
	jd_allItems["Eodiaphyodus"] = 1;
	jd_allItems["Rhombodus"] = 1;
	jd_allItems["Goulmimicthys"] = 1;
	jd_allItems["Fish - Museum Grade"] = 1;
	jd_allItems["Devonian Fossil Fishes"] = 1;
	jd_allItems["USA Fossil Fishes"] = 1;
	jd_allItems["Solnhofen Fossil Fishes"] = 1;
	jd_allItems["Akrabou Fm Fossil Fishes"] = 1;
	jd_allItems["Lebanon Fossil Fishes"] = 1;
	jd_allItems["Monte Bolca Fossil Fishes"] = 1;
	jd_allItems["Brazilian Fossil Fishes"] = 1;
	jd_allItems["Triassic Fossil Fishes"] = 1;
	jd_allItems["Carboniferous Fossil Fishes"] = 1;
	jd_allItems["China Fossil Fishes"] = 1;
	jd_allItems["Messel Fossil Fishes"] = 1;
jd_allItems["Invertebrates, Minerals & Meteorites"] = 0;
    jd_allItems["Trilobites"] = 1;
	jd_allItems["Echinoderms"] = 1;
    jd_allItems["Geological Samples"] = 1;
	jd_allItems["Amber Inclusions"] = 1;
    jd_allItems["Cephalopods"] = 1;
    jd_allItems["Meteorites"] = 1;
    jd_allItems["Minerals"] = 1;
	jd_allItems["Corals"] = 1;
    jd_allItems["Plants & Petrified wood"] = 1;
	jd_allItems["Primitive Tools"] = 1;
	jd_allItems["Crustaceans"] = 1;
	jd_allItems["Rancho La Brea Insects"] = 1;

		jd_allItems["Carboniferous Plants"] = 2;
    jd_allItems["Brachiopods"] = 1;
    jd_allItems["Fossil Stoneware"] = 1;
	jd_allItems["Gastropods"] = 1;
	jd_allItems["Exceptionally Preserved Fossils"] = 1;
	jd_allItems["Fezouata Formation (Burgess shale type)"] = 1;
	jd_allItems["Graptolites"] = 1;
	jd_allItems["Primitive arthropods"] = 1;

jd_mainCategory = ""; // The deepest category available. It will be used for recommending related products.

function jd_generateBreadcumb( arrayCollections, arrayCollectionsHandles )
{
  orderedCollections = new Array(arrayCollections.length);
  orderedCollectionsHandles = new Array(arrayCollections.length);
  collectionsCounter = 0;
  
  for(var i=0; i<arrayCollections.length; i++)
  {
    if( jd_allItems[arrayCollections[i]] != undefined )
    {
      orderedCollections[jd_allItems[arrayCollections[i]]] = arrayCollections[i];
      orderedCollectionsHandles[jd_allItems[arrayCollections[i]]] = arrayCollectionsHandles[i];
      collectionsCounter = collectionsCounter + 1;
    }
  }
  
  retVal = "";
  for(var i=0; i<collectionsCounter; i++)
  {
    if( i == (collectionsCounter-1) )
    {
      jd_mainCategory = orderedCollectionsHandles[i];
    }
    retVal = retVal + "<a href=\"http://www.jurassic-dreams.com/collections/" + orderedCollectionsHandles[i] + "\">" + orderedCollections[i] + "</a> &rsaquo; ";
  }
  
	
  return retVal;
}